import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 * CommonImage view component class.
 * @function CommonImage
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */
const CommonImage = (params) => {
  return (
    <div className={cx('', params.container_class)}>
      <>
        {params.image && (
          <img
            src={flattenToAppURL(params.image)}
            className={cx('', params.image_class)}
            alt={params.caption || params.title}
            title={params.caption || params.title}
          />
        )}
        {params.caption && (
          <figcaption className="figure-caption text-center pt-3">
            {params.caption}
          </figcaption>
        )}
      </>
    </div>
  );
};
export default CommonImage;

CommonImage.propTypes = {
  params: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      download: PropTypes.string,
    }),
    caption: PropTypes.string,
    container_class: PropTypes.string,
    image_class: PropTypes.string,
    // size: PropTypes.shape({
    //   width: PropTypes.number,
    //   height: PropTypes.number
    // })
  }),
};
